import { render, staticRenderFns } from "./CollectionBasisInfo.vue?vue&type=template&id=872210ec&scoped=true"
import script from "./CollectionBasisInfo.vue?vue&type=script&lang=js"
export * from "./CollectionBasisInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectionBasisInfo.vue?vue&type=style&index=0&id=872210ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872210ec",
  null
  
)

export default component.exports